import axios from 'axios';
import { API_URL } from '../config/apiConfig';


// ===================== AFFILIATE COMPETITIONS (MY AFFILIATE) =====================

export const getAffiliateCompetitions = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/affiliate-competitions`, {
            params: { affiliateId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching affiliate competitions:", error);
        throw error;
    }
};

export const createCompetition = async (competitionData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${API_URL}/competitions`, competitionData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error creating competition:", error);
        throw error;
    }
};

export const updateCompetition = async (competitionId, competitionData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/competitions/${competitionId}`, competitionData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error updating competition:", error);
        throw error;
    }
};

export const deleteCompetition = async (competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${API_URL}/competitions/${competitionId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting competition:", error);
        throw error;
    }
};

// ===================== PUBLIC COMPETITIONS (REGISTER TRAINING PAGE) =====================

export const getPublicCompetitions = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/public-competitions`, {
            params: { affiliateId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching public competitions:", error);
        throw error;
    }
};

export const getCompetitionDetails = async (competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/competitions/${competitionId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching competition details:", error);
        throw error;
    }
};

// ===================== WORKOUTS =====================

export const addCompetitionWorkout = async (competitionId, workoutData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/competitions/${competitionId}/workouts`,
            workoutData,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error adding workout:", error);
        throw error;
    }
};

export const updateCompetitionWorkout = async (workoutId, workoutData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/workouts/${workoutId}`, workoutData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error updating workout:", error);
        throw error;
    }
};

export const deleteCompetitionWorkout = async (workoutId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${API_URL}/workouts/${workoutId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting workout:", error);
        throw error;
    }
};

// ===================== REGISTRATIONS =====================

// User self-registration (full process with validation, notifications, etc.)
export const registerForCompetition = async (competitionId, registrationData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/competitions/${competitionId}/register`,
            registrationData,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error registering for competition:", error);
        throw error;
    }
};

// Admin adds competitor (simple registration - only saves user/team data)
export const addCompetitorByAdmin = async (competitionId, competitorData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/competitions/${competitionId}/add-competitor`,
            competitorData,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error adding competitor:", error);
        throw error;
    }
};

export const getUserRegistrations = async (userId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/user-registrations`, {
            params: { userId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching user registrations:", error);
        throw error;
    }
};

// ===================== LEADERBOARD & RESULTS =====================

export const getCompetitionLeaderboard = async (competitionId, workoutId = null) => {
    try {
        const token = localStorage.getItem("token");
        const params = workoutId ? { workoutId } : {};
        const response = await axios.get(`${API_URL}/competitions/${competitionId}/leaderboard`, {
            params,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching leaderboard:", error);
        throw error;
    }
};

export const submitCompetitionResult = async (competitionId, workoutId, resultData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/competitions/${competitionId}/workouts/${workoutId}/results`,
            resultData,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error submitting result:", error);
        throw error;
    }
};

// ===================== SCHEDULE =====================

export const getCompetitionSchedules = async (competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/competitions/${competitionId}/schedules`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching schedules:", error);
        throw error;
    }
};

export const createSchedule = async (competitionId, scheduleData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/competitions/${competitionId}/schedules`,
            scheduleData,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error creating schedule:", error);
        throw error;
    }
};

export const updateSchedule = async (scheduleId, scheduleData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/schedules/${scheduleId}`, scheduleData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error updating schedule:", error);
        throw error;
    }
};

export const deleteSchedule = async (scheduleId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${API_URL}/schedules/${scheduleId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting schedule:", error);
        throw error;
    }
};

export const createHeat = async (scheduleId, heatData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/schedules/${scheduleId}/heats`,
            heatData,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error creating heat:", error);
        throw error;
    }
};

export const updateHeat = async (heatId, heatData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/heats/${heatId}`, heatData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error updating heat:", error);
        throw error;
    }
};

export const deleteHeat = async (heatId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${API_URL}/heats/${heatId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting heat:", error);
        throw error;
    }
};

export const updateLane = async (laneId, laneData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/lanes/${laneId}`, laneData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error updating lane:", error);
        throw error;
    }
};

// Search users for assigning to lanes
export const searchUsers = async (searchTerm, competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/search-users`, {
            params: { q: searchTerm, competitionId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error searching users:", error);
        throw error;
    }
};

// Lisa see otsingufunktsioonide juurde
export const getCompetitionTeams = async (competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/competitions/${competitionId}/teams`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching competition teams:", error);
        throw error;
    }
};

// Get all individual competitors for a competition
export const getCompetitionCompetitors = async (competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/competitions/${competitionId}/competitors`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching competition competitors:", error);
        throw error;
    }
};

// ===================== RESULT APPROVAL =====================

export const approveCompetitionResult = async (resultId, approved) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(
            `${API_URL}/results/${resultId}/approve`,
            { approved },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error approving result:", error);
        throw error;
    }
};

// ===================== REGISTRATION MANAGEMENT =====================

export const deleteCompetitionRegistration = async (registrationId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${API_URL}/registrations/${registrationId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting registration:", error);
        throw error;
    }
};

export const updateCompetitionRegistration = async (registrationId, registrationData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/registrations/${registrationId}`, registrationData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error updating registration:", error);
        throw error;
    }
};

// ===================== JUDGES =====================

export const getCompetitionJudges = async (competitionId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/competitions/${competitionId}/judges`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching competition judges:", error);
        throw error;
    }
};

export const addCompetitionJudge = async (competitionId, userId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${API_URL}/competitions/${competitionId}/judges`,
            { userId },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error adding competition judge:", error);
        throw error;
    }
};

export const removeCompetitionJudge = async (competitionId, judgeId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(
            `${API_URL}/competitions/${competitionId}/judges/${judgeId}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error removing competition judge:", error);
        throw error;
    }
};